<template>
  <v-dialog v-model="imageViewer" max-width="1024">
    <v-card>
      <v-card-text class="pa-0">
        <v-img
          :src="imageViewerLink"
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          height="100%"
        >
        </v-img>
        <v-icon class="svg-icon close-icon" @click="imageViewer = false"
          >mdi-close</v-icon
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ImageViewer',
  computed: {
    ...mapGetters({
      imageViewerLink: 'global/getImageViewerLink',
    }),
    imageViewer: {
      get() {
        return this.$store.getters['global/getImageViewer'];
      },
      set(value) {
        this.$store.commit('global/setImageViewer', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.close-icon {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 10px;
  margin-right: 10px;
  color: #ffa726;
  border-radius: 20px;
  border-color: none;
  background-color: #ffffffdb;
}
</style>
